module.exports = __webpack_public_path__ + "img/vertical_4_5_9006.6555e61e.png";